import { Form } from "react-bootstrap";
import Chip from "../../Img/Card/chip.png";
import {
  FaRegCopy,
  FaCheck,
} from "react-icons/fa"
import { useEffect, useState } from "react";
import { superAdminMetaServices } from "../../APIServices/MetaManagement/superAdminMetaServices";
import AdditionalDetails from "./AdditionalDetails";

const ViewCardDetails = ({ auth, itemData, hideShow, setHideShow, activeItem, plateformSettings }) => {
  const [copiedField, setCopiedField] = useState(null);
  const [bankName, setBankName] = useState("");
  const [bankIcon, setBankIcon] = useState("");
  const [cardName, setCardName] = useState("");
  const [cardIcon, setCardIcon] = useState("");
  const [cardColor, setCardColor] = useState("");

  function formatCardNumber(cardNumber) {
    return cardNumber
      .replace(/\s+/g, "")
      .replace(/(.{4})/g, "$1 ")
      .trim();
  }

  function maskNumber(number) {
    const str = number.toString();
    const last4 = str.slice(-4);
    return "XXXX XXXX XXXX " + last4;
  }

  const handleCopy = (text, field) => {
    navigator.clipboard.writeText(text);
    setCopiedField(field);
    setTimeout(() => setCopiedField(null), 1500);
  };

  const renderCopyIcon = (field, value, fontSize, marginTop) =>
    copiedField === field ? (
      <FaCheck style={{ marginTop: marginTop, fontSize: fontSize }} />
    ) : (
      <FaRegCopy
        style={{ cursor: "pointer", marginTop: marginTop, fontSize: fontSize }}
        title="Copy"
        onClick={() => handleCopy(value, field)}
      />
    );

  const randerCardData = async (key) => {
    let data = await superAdminMetaServices.getSingleMetadata(auth, "creditdebit", key)
    setCardName(data?.data?.name)
    setCardIcon(data?.data?.icon)
    setCardColor(data?.data?.bgColor)
  };
  
  const randerBankData = async (key) => {
    let data = await superAdminMetaServices.getSingleMetadata(auth, "bankaccount", key)
    setBankName(data?.data?.name)
    setBankIcon(data?.data?.icon)
  };

  const randerValue = (name) => {
    let getData = (itemData?.itemInfo || [])?.find(item => item.name === name)
    return getData?.value
  };

  useEffect(() => {
    let cardData = (itemData?.itemInfo || [])?.find(item => item.name === "CARD_TYPE")?.value
    if(cardData){
      randerCardData(cardData);
    }
    let bankData = (itemData?.itemInfo || [])?.find(item => item.name === "BANK")?.value
    if(bankData){
      randerBankData(bankData);
    }
  }, [itemData]);
  return (
    <>
      <div className="hstack justify-content-between">
        <h6 className="m-0"><img style={{ marginTop: -4 }} width={20} height={20} src={bankIcon} /> {bankName}</h6>
        {!(activeItem === "archived" || activeItem === "trash") && (!plateformSettings?.settings?.privacySettings?.hideShowConfidentialsDataOption && !plateformSettings?.settings?.showPrivacySettings?.hideShowConfidentialsDataOption) &&
          <Form.Check
            type="switch"
            className="m-0"
            label={hideShow ? "Hide" : "Show"}
            checked={hideShow}
            style={{ fontSize: 13 }}
            onChange={() => setHideShow(!hideShow)}
          />
        }
      </div>
      <div style={{ background: cardColor }} className="cardDesign p-4 rounded-4 shadow-sm mb-3">
        <div className="hstack justify-content-between ">
          <span className="hstack gap-2 text-white">
            <img src={cardIcon} style={{ width: 50 }} className="me-2" alt="" />
            <h5 style={{ fontSize: 16 }} className="m-0">
              {cardName}
            </h5>
          </span>
          <img src={Chip} alt="" className="chip" style={{ width: 45 }} />
        </div>

        <div className="d-flex justify-content-between mt-5 flex-end">
          <div className="text-white">
            <h6 style={{ fontSize: 10 }}>Card Number</h6>
            <h5 style={{ fontSize: 16 }} className="mt-2">
              {hideShow ? formatCardNumber(randerValue("CARD_NUMBER")) : maskNumber(randerValue("CARD_NUMBER"))}
              {!(activeItem === "archived" || activeItem === "trash") && (!plateformSettings?.settings?.privacySettings?.hideShowCopyOption && !plateformSettings?.settings?.showPrivacySettings?.hideShowCopyOption) &&
                <>
                  {" "}{renderCopyIcon("cardNumber", randerValue("CARD_NUMBER"), 14, -4)}
                </>
              }
            </h5>
            <h5 style={{ fontSize: 16 }} className="mt-4">
              {randerValue("CARD_HOLDER_NAME")}
              {!(activeItem === "archived" || activeItem === "trash") && (!plateformSettings?.settings?.privacySettings?.hideShowCopyOption && !plateformSettings?.settings?.showPrivacySettings?.hideShowCopyOption) &&
                <>
                  {" "}{renderCopyIcon("cardHolderName", randerValue("CARD_HOLDER_NAME"), 14, -4)}
                </>
              }
            </h5>
          </div>
          <div className="text-white">
            <h6 style={{ fontSize: 10 }}>Valid Thru</h6>
            <h5 style={{ fontSize: 16 }}>{randerValue("EXPIRY_DATE")}</h5>
            <h6 style={{ fontSize: 10 }} className="mt-4">
              CVV <span style={{ fontSize: 16 }}>{hideShow ? randerValue("CVV_NUMBER") : "..."}</span>
              {!(activeItem === "archived" || activeItem === "trash") && (!plateformSettings?.settings?.privacySettings?.hideShowCopyOption && !plateformSettings?.settings?.showPrivacySettings?.hideShowCopyOption) &&
                <>
                  {" "}{renderCopyIcon("cvvNumber", randerValue("CVV_NUMBER"), (hideShow ? 14 : 12), (hideShow ? -8 : -4))}
                </>
              }
            </h6>
          </div>
        </div>
      </div>
      <div className="overflow-auto" style={{height: "calc(100vh - 400px)"}}>
        <AdditionalDetails
          itemData={itemData}
          activeItem={activeItem}
          plateformSettings={plateformSettings}
        />
      </div>
    </>
  );
};

export default ViewCardDetails;
